import {useState } from "react";

const UserProductReadOnlyRow = ({ key, t, userProductItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, userProductItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, userProductItem, submitComplete);
	}

	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userProductItem.productGroupName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userProductItem.commodityName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userProductItem.productName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userProductItem.productSku}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userProductItem.description}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{userProductItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, userProductItem)}>
					{userProductItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default UserProductReadOnlyRow;